export const VTextFieldConfig = {
  density: 'compact',
  variant: 'outlined',
};
